import React, { useState } from 'react';
import RoomStatusTable from './Components/RoomStatusTable';
import AddRoomModal from './Components/AddRoomModal';

const RoomStatus = () => {
  const [showModal, setShowModal] = useState(false);

  const handleAddRoom = (newRoomData) => {
    console.log('New Room:', newRoomData);
    setShowModal(false);
    
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room Status</h3>
            <button
                className="btn btn-dark"
                onClick={() => setShowModal(true)}
                >
                + Add Room
            </button>
          </div>
        </div>

        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <RoomStatusTable />
            </div>
          </div>
        </div>
      </div>

      <AddRoomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleAddRoom}
      />
    </div>
  );
};

export default RoomStatus;
